module.exports = __webpack_public_path__ + "images/choices/qrcode-gujia-c76001ffb6533d58ba1b7b0c9944d782.jpg";